import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import FontAwesome from 'react-fontawesome';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { EliminarConfirmacionC } from 'modules/general/component';

import * as preciosActions from 'modules/precios/action';
import * as generalActions from 'modules/general/action';

@connect((store) => ({
  listaPrecios: store.getIn(['precios', 'lista']),
  eliminarId: store.getIn(['precios', 'eliminarId']),
}))
export default class extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('PRECIOS'));
    if (this.props.listaPrecios.size <= 1) this.props.dispatch(preciosActions.get());
  };

  add = () => this.props.dispatch(push('/dashboard/precios/add/'));

  update = (precioNombre) => this.props.dispatch(push(`/dashboard/precios/add/${precioNombre}`));

  delete = (precioId) => this.props.dispatch(preciosActions.setState({ eliminarId: precioId }));

  cancelarDelete = () => this.props.dispatch(preciosActions.setState({ eliminarId: false }));

  confirmDelete = () => {
    this.props.dispatch(preciosActions.deleteItem(this.props.eliminarId));
    this.cancelarDelete();
  };

  render = () => {
    const { listaPrecios } = this.props;
    return (
      <div>
        <Row className="rowContainer textCenter">
          <Col md={{ size: 10, offset: 1 }}>
            <MaterialUI.Paper zDepth={2} className="container">
              <MaterialUI.List className="noPadding dividerList">
                {listaPrecios &&
                  listaPrecios.map((precio) => (
                    <div key={precio.get('id')}>
                      <Row style={{ padding: 10, paddingTop: 20 }}>
                        <Col md="3">
                          <h4 id={precio.get('id')} className="bolder">
                            {precio.get('nombre')}
                          </h4>
                        </Col>
                        <Col md="2">
                          <h4 className={precio.get('activo') ? 'bolder green' : 'bolder yellow'}>
                            <FontAwesome name="dollar" />
                            {precio.get('precio')}
                          </h4>
                        </Col>
                        <Col md="2">
                          <p>
                            <FontAwesome name="calendar" style={{ paddingRight: 10 }} />
                            Fecha de inicio:
                          </p>
                          <p className="bolder">{moment(precio.get('fechaInicio')).format('DD/MM/YYYY')}</p>
                        </Col>
                        <Col md="2">
                          <h4 className={precio.get('activo') ? 'bolder green' : 'bolder yellow'}>{precio.get('activo') ? 'Activo' : 'Inactivo'}</h4>
                        </Col>
                        {precio.get('_creadoBy') && (
                          <Col md="2">
                            <p>
                              <FontAwesome name="user" style={{ paddingRight: 10 }} />
                              Creado por:
                            </p>
                            <p className="bolder">
                              {precio.getIn(['_creadoBy', 'nombre'])} {precio.getIn(['_creadoBy', 'apellido'])}{' '}
                            </p>
                          </Col>
                        )}
                        <Col md="1">
                          <MaterialUI.IconMenu
                            iconButtonElement={
                              <MaterialUI.IconButton touch={true} tooltipPosition="bottom-left">
                                <MoreVertIcon />
                              </MaterialUI.IconButton>
                            }
                          >
                            <MaterialUI.MenuItem onTouchTap={this.update.bind(this, precio.get('nombre'))}>
                              <FontAwesome name="edit" className="blue" /> Actualizar
                            </MaterialUI.MenuItem>
                            <MaterialUI.MenuItem onTouchTap={this.delete.bind(this, precio.get('id'))}>
                              <FontAwesome name="trash" className="red" /> Eliminar
                            </MaterialUI.MenuItem>
                          </MaterialUI.IconMenu>
                        </Col>
                      </Row>
                      <MaterialUI.Divider />
                    </div>
                  ))}
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
        </Row>

        <MaterialUI.FloatingActionButton className="bottonFlotanteAdd" onTouchTap={this.add.bind(this)}>
          <FontAwesome name="plus" />
        </MaterialUI.FloatingActionButton>

        <EliminarConfirmacionC eliminarId={this.props.eliminarId} confirmar={this.confirmDelete} cancelar={this.cancelarDelete} />
      </div>
    );
  };
}



// WEBPACK FOOTER //
// src/modules/precios/components/main.js